import React from 'react';
import './remove-user.modal.sass';
import { Button, ButtonSize, ButtonType } from '../../../../../components/interface/button/button';
import { Modal } from '../../../../../components/modal/modal';
import { useDispatch } from 'react-redux';
import { deleteTeamUser, getTeamUsers } from '../../dashboard-team.slice';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

export const RemoveUserModal = ({userId, vendorId, isVisible, setIsVisible}) => {

  const dispatch = useDispatch();

  const deleteUser = () => {
    dispatch(deleteTeamUser({userId: userId, vendorId: vendorId}))
      .then(unwrapResult)
      .then( () => {
        toast.success('Użytkwonik został usunięty!');
        dispatch(getTeamUsers({vendorId}));
        setIsVisible(false);
      }, () => {
        toast.error('Coś poszło nie tak : (');
      });
  };

  return (
    <Modal isOpen={isVisible} title='Usuń z listy pracowników' setVisible={setIsVisible} width={692} height={208}>
      <div className='vv-remove-user-modal'>
        <Button type='submit' text='USUń' buttonSize={ButtonSize.VENDOR} buttonType={ButtonType.BLACK} onClick={deleteUser}/>
        <Button type='submit' text='ANULUJ' buttonSize={ButtonSize.VENDOR} buttonType={ButtonType.TRANSPARENT_BORDER} onClick={() => setIsVisible(false)}/>
      </div>
    </Modal>
  );
};
